import axios from "axios";
import { Toast } from 'vant'
import qs from 'qs'
import { getEnv } from '@/utils/tool'

const baseUrl = {
  'development': '/',
  'pre': '/',
  'production': '/'
}

const service = axios.create({
  baseURL: baseUrl[process.env.NODE_ENV],
  timeout: 50000
});

const permissionList = ["studioid", "buildversion", "idfa", "bundleid", "userid", "deviceid", "uuid", "platform", "token", "network", "opertaion", "studio_name", "uuidnew", "idfanew", "imei", "sversion", "model", "cversion", "device", "timestamp"]
service.interceptors.request.use(
  config => {
    if(config.method.toLocaleLowerCase() === 'get'){
      let urlAppend = '?';
      if(config.data) {
        Object.keys(config.data).forEach(key => {
          urlAppend += `${key}=${config.data[key]}&`;
        });
        urlAppend = urlAppend.substr(0, urlAppend.length - 1);
        config.url += urlAppend;
      }
    }
    
    // 智慧校园客户端 统一取localStorage中的header_json
    if(getEnv() === 'app') {
      // 接口鉴权
      const header_json = localStorage.getItem('header_json')
      if(header_json) {
        for(let key in JSON.parse(header_json)){
          if(permissionList.indexOf(key) > -1){
            config.headers[key] = encodeURI(JSON.parse(header_json)[key])
          }
        }
      }
      config.headers.from = 'backend'
    }

    // h5环境 家长端使用token 其他路由携带channel为画室id埋入localStorage
    if(getEnv() === 'h5') {
      const token = localStorage.getItem('token')
      if(token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      const channel = localStorage.getItem('channel')
      if(channel) {
        config.headers.studioid = channel
      }
      const userid = localStorage.getItem('userid') //todo
      if(userid) {
        config.headers.userid = userid
      }
    }

    // api传入请求头 可能会覆盖鉴权请求头
    if(config.reqHeader){
      for(let key in config.reqHeader){
        config.headers[key] = config.reqHeader[key]
      }
      if(config.reqHeader['content-type'] && config.reqHeader['content-type'] === 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(config.data)
      }
    }
    return config;
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
);

service.interceptors.response.use(
  response => {
    const res = response.data;
    if(res.status === 0) {
      return res
    } else {
      if (res.code !== 0) {
        Toast(res.message)
        return Promise.reject(res)
      } else {
        return res
      }
    }
  },
  error => {
    if(error.message.includes('401')) {
      Toast('身份验证失败')
    }
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/http.js